module.exports = __webpack_public_path__ + "img/security_icon.233459f5.webp";